import { Component } from 'react';
import { Section } from './comps/Section.jsx';
import { Notification } from './comps/Notification.jsx';
import { FeedbackOptions } from './comps/FeedbackOptions.jsx';
import { Statistics } from './comps/Statistics.jsx';

class App extends Component {
  state = {
    good: 0,
    neutral: 0,
    bad: 0,
  }
  
  countTotalFeedback = () => this.state.good + this.state.neutral + this.state.bad;
  
  addGood = () => {
    this.setState((prevState) => ({
      good: prevState.good + 1
    }))
  }
  
  addNeutral = () => {
    this.setState((prevState) => ({
      neutral: prevState.neutral + 1
    }))
  }
  
  addBad = () => {
    this.setState((prevState) => ({
      bad: prevState.bad + 1
    }))
  }
  
  render() {
    return (
      <>
        <Section title="Please feedback">
          <FeedbackOptions addGood={this.addGood} addNeutral={this.addNeutral} addBad={this.addBad} />
        </Section>
        <Section title="Statistics">
          {this.countTotalFeedback() > 0 ? (<Statistics good={this.state.good} neutral={this.state.neutral} bad={this.state.bad} />) : (<Notification message="There is no feedback" />)}
        </Section>
      </>
    );
  }
}


export default App;